"use strict";

import "../../scss/pages/awards-details.scss";
import "bootstrap/js/dist/tab";
import PublicationsTable from "../components/publicationTable";
import FormatString from "../helpers/formatString";
import axios from "axios";
import GlobalError from "../helpers/globalError";

export default class AwardsDetails {
	
	loadAwardsDetails(selectedPublicationType, isTabType = true, year = null) {
		const language = document.querySelector('#dropdownlanguageMenu');
		const currentUrl = window.location.pathname.split('/');
		const publicationTypeClassname = selectedPublicationType === 'broadband' ? 'fixed' : selectedPublicationType;
		const loader = document.querySelector('#loaderDetailsTab');
		loader.classList.remove('d-none');
		
		axios.post(`/${ language.dataset.languageSelected }/index/awards-details-by-filter`,
				{
					countryIsoCode: currentUrl[3],
					year: year ? parseInt(year) : parseInt(currentUrl[4]),
					publicationType: selectedPublicationType,
					isTabType: isTabType,
					locale: language.dataset.languageSelected
				}
			)
			.then((response) => {
				const containerAwardsRating = document.querySelector('.container-rating-year .tab-content');
				if (containerAwardsRating) {
					containerAwardsRating.innerHTML = response.data;
				}
				
				if (isTabType) {
					const containerTab = document.querySelector('#containerTabType');
					if (containerTab) {
						containerTab.innerHTML = response.data;
						const buttonYearSelected = document.querySelector('.container-tab-subparent .btn-year.active');
						const buttonYearList = document.querySelectorAll('.container-tab-subparent .btn-year');
						const sessionYear = sessionStorage.getItem(currentUrl[3]+"-"+selectedPublicationType);

						if (!buttonYearSelected) {
							this.updateAwardsDetailsUrl({
								year: sessionYear ?? [...buttonYearList][0].dataset.year,
							});
							this.loadAwardsDetails(selectedPublicationType);

						} else {
								this.updateAwardsDetailsUrl({
									networkType: selectedPublicationType,
									year: sessionYear ?? null,
								});
								if(sessionYear){
									document.querySelectorAll('.btn-year').forEach((btn) => {
										btn.classList.remove('active');
									})
									document.querySelector('.btn-year[data-year="' + sessionYear + '"]').click();
									this.loadAwardsDetails(selectedPublicationType, false, sessionYear);
								}
						}

						$('a.btn-year').on('shown.bs.tab', (event) => {
							sessionStorage.setItem(currentUrl[3]+"-"+selectedPublicationType, event.target.dataset.year);
							this.loadAwardsDetails(event.target.dataset.type === 'fixed' ? 'broadband' : event.target.dataset.type, false, event.target.dataset.year);
							const newAwardsDetailsUrl = {
								year: event.target.dataset.year,
							}
							this.updateAwardsDetailsUrl(newAwardsDetailsUrl);
							const slider = document.querySelector('.container-tab-subparent');
							const containerSlider = document.querySelector('.container-tab-parent');
							const buttonYearList = document.querySelectorAll(`#ratingYear${ FormatString.capitalize(event.target.dataset.type) } .btn-year`);
							const boundingXMin = 0;
							const boundingXMax = slider.scrollWidth - containerSlider.getBoundingClientRect().width;
							
							buttonYearList.forEach((buttonYear, buttonIndex) => {
								if (event.target.dataset.year === buttonYear.dataset.year) {
									if (buttonIndex < 3) {
										containerSlider.scrollLeft = boundingXMin;
									} else if (buttonIndex === 3) {
										containerSlider.scrollLeft = boundingXMax;
									}
								} else {
									buttonYear.classList.remove('active');
								}
								
							});
						});
						
						const publicationsTableModule = new PublicationsTable();
						const containerFilter = document.querySelector(`.filterContainer${ FormatString.capitalize(publicationTypeClassname) }`);
						publicationsTableModule.refreshPublicationsTable(true, `#loaderTab${ FormatString.capitalize(publicationTypeClassname) }`, `#tableContainerTab${ FormatString.capitalize(publicationTypeClassname) }`, containerFilter);
					}
				}
				
			})
			.catch((error) => {
				if (error && error.response && error.response.data.errors) {
					loader.classList.add('d-none');
					GlobalError.openErrorModal(error.response.data.errors.message, 'globalAwardsDetails');
				}
				
				if (error && error.response.status === 404 && isTabType) {
					const buttonTab = document.querySelector(`#tab${ FormatString.capitalize(publicationTypeClassname) }`);
					this.updateAwardsDetailsUrl({
						year: buttonTab.dataset.lastPublication,
					});
					this.loadAwardsDetails(selectedPublicationType);
				}
			})
			.finally(function () {
				loader.classList.add('d-none');
			});
	}
	
	/**
	 * Update parameters on awards details url
	 * @param newUrl - Object - parameters url
	 */
	updateAwardsDetailsUrl = (newUrl) => {
		const locale = newUrl.locale ? newUrl.locale : window.location.pathname.split('/')[1];
		const countryCode = newUrl.countryCode ? newUrl.countryCode : window.location.pathname.split('/')[3];
		const year = newUrl.year ? newUrl.year : window.location.pathname.split('/')[4];
		const countryFrFullName = newUrl.countryFrName ? newUrl.countryFrName : window.location.pathname.split('/')[6];
		const networkType = newUrl.networkType ? newUrl.networkType : window.location.pathname.split('/')[5];
		
		const url = `/${ locale }/awards/${ countryCode }/${ year }/${ networkType }/${ countryFrFullName }`;
		history.replaceState({nPerf: 'awardsDetails'}, '', url);
	}
}

document.addEventListener("DOMContentLoaded", function () {
	const awardsDetailsModule = new AwardsDetails();
	const activeTab = document.querySelector('a.tab-network-type.active');
	const containerRankingTableList = document.querySelectorAll('.table-responsive');
	const buttonAwardDownloadList = document.querySelectorAll('.awardsDetails-page .btn-barometer');
	
	buttonAwardDownloadList.forEach((buttonAwardDownload) => {
		buttonAwardDownload.addEventListener('click', () => {
			/* eslint-disable */
			_paq.push(['trackEvent', 'publicationDetails', buttonAwardDownload.dataset.tag]);
			/* eslint-enable */
		})
	});
	awardsDetailsModule.loadAwardsDetails(activeTab.dataset.networkType);
	
	$('a.tab-network-type').on('shown.bs.tab', function (event) {
		awardsDetailsModule.loadAwardsDetails(event.target.dataset.networkType === 'fixed' ? 'broadband' : event.target.dataset.networkType);
	});
	
	containerRankingTableList.forEach((containerRankingTable) => {
		const containerTable = containerRankingTable.closest('.container-table');
		
		containerRankingTable.addEventListener('scroll', () => {
			const bodyRTL = document.querySelector('body[dir="rtl"]');
			if (bodyRTL) {
				if (containerRankingTable.scrollLeft >= 1) {
					containerTable.classList.remove('scroll-table-right');
				} else if ((containerRankingTable.scrollLeft - containerRankingTable.getBoundingClientRect().width) === -(containerRankingTable.querySelector('.table').scrollWidth - 1)) {
					containerTable.classList.remove('scroll-table-left');
				} else {
					containerTable.classList.add('scroll-table-right', 'scroll-table-left');
				}
			} else {
				if (containerRankingTable.scrollLeft === 0) {
					containerTable.classList.remove('scroll-table-left');
				} else if ((containerRankingTable.scrollLeft + containerRankingTable.getBoundingClientRect().width) === containerRankingTable.querySelector('.table').scrollWidth) {
					containerTable.classList.remove('scroll-table-right');
				} else {
					containerTable.classList.add('scroll-table-right', 'scroll-table-left');
				}
			}
			
		})
	})
	
});
